import AvatarImage from '@pelckmans/elementis/components/avatar/avatar-image';
import Breadcrumbs from '@pelckmans/elementis/components/breadcrumbs';
import { useContext } from 'react';
import ModuleContext from '../../pages/material/_contexts/ModuleContext';
import { useMaterialLinkBuilder } from '../../hooks/useMaterialLinkBuilder';
import { useTranslation } from 'react-i18next';

interface ModuleBreadcrumbsProps {
  size: 'sm' | 'md';
}

export default function ModuleBreadcrumbs({ size }: ModuleBreadcrumbsProps) {
  const { t } = useTranslation();

  const { module, selectedModule } = useContext(ModuleContext);
  const { buildMaterialLink, buildMaterialTocLink } = useMaterialLinkBuilder();

  if (!module) return null;

  return (
    <Breadcrumbs size={size} aria-label={t('MODULE_BREADCRUMB.A11Y_LABEL')}>
      <Breadcrumbs.Item
        avatarImage={module.styling?.logo ? <AvatarImage name={module.name} src={module.styling?.logo} /> : undefined}
        to={buildMaterialLink() || ''}
      >
        {module.name}
      </Breadcrumbs.Item>
      {selectedModule && (
        <Breadcrumbs.Item
          avatarImage={
            selectedModule.styling?.logo ? (
              <AvatarImage name={selectedModule.niceName} src={selectedModule.styling?.logo} />
            ) : undefined
          }
          to={buildMaterialTocLink() || ''}
        >
          {selectedModule.niceName}
        </Breadcrumbs.Item>
      )}
    </Breadcrumbs>
  );
}
